import styles from './EnvironmentBanner.module.css';
import { Helpers } from '../../../utils/helpers';

export const EnvironmentBanner = () => {
  const bannerText = import.meta.env.VITE_APP_BANNER_TEXT;
  if (Helpers.isNullOrWhiteSpace(bannerText)) {
    return <></>;
  }
  return <div className={styles.environmentBanner}>{bannerText}</div>;
};

export default EnvironmentBanner;
